/**
 * @Time    : 2024/01/10 11:41
 * @Author  : tlovet
 * @Software: WebStorm
 */

/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import Footer from './Footer';
import {
  AvatarDropdown,
  AvatarName,
  EnvDropdown,
  FullScreen,
  Question,
  SearchInput,
  SelectLang,
  ThemeSwitch,
} from './Header';

export {
  AvatarDropdown,
  AvatarName,
  EnvDropdown,
  Footer,
  FullScreen,
  Question,
  SearchInput,
  SelectLang,
  ThemeSwitch,
};
